import * as React from 'react';
import { Store } from 'redux';

import { createMakeRequest } from '../../../browser/client';
import { Header } from '../../components/header/header';

import { ACTIVE_EXPERIMENTS, getExperimentsFlags } from '../../redux/modules/mainpage';
import { getUserData } from '../../redux/modules/user';

const styles = require('./app.css');

interface IProps {
  store?: Store;
}

export class App extends React.Component<IProps, {}> {
  public componentDidMount() {
    const { store } = this.props;

    if (store) {
      // tslint:disable-next-line:no-any
      const host = window.__mainpage_api_host__ || window.location.host;

      store.dispatch(getUserData(host) as any);

      getExperimentsFlags(
        store.dispatch,
        createMakeRequest(host),
        ACTIVE_EXPERIMENTS,
        document.cookie,
        window.location.search.replace('?', ''),
      );
    }
  }

  public render() {
    return (
      <section id={styles['mainpage']}>
        <Header />
        {this.props.children}
      </section>
    );
  }
}
